import { CSSProperties } from "react";
import { type ThemeId } from "../../domain/theme";
import * as css from "./swatch.css";

/**
 * Previews a theme's colors regardless of the currently applied theme.
 */
export function ThemeSwatch(props: {
  theme: ThemeId;
  size: string;
  hollow?: boolean;
  inline?: boolean;
}) {
  const displayProps: CSSProperties = props.inline
    ? {
        display: "inline-block",
        verticalAlign: "middle",
        position: "relative",
        top: "-1px",
      }
    : {};

  return (
    <svg
      viewBox="0 0 16 16"
      className={css.swatch[props.theme]}
      style={{
        ...displayProps,
        inlineSize: props.size,
      }}
      aria-hidden
    >
      <path
        d="M8 4 L12 8 L8 12 L4 8 Z"
        strokeWidth="1"
        vectorEffect="non-scaling-stroke"
        className={`${css.diamond} ${props.hollow ? css.hollow : ""}`}
      />
    </svg>
  );
}
